import { default as MarkdownComponent } from 'react-markdown';
export type { Components as MarkdownComponents } from 'react-markdown';
export type { PluggableList } from 'unified';
export { default as remarkParse } from 'remark-parse';
export { default as remarkRehype } from 'remark-rehype';
export { default as rehypeStringify } from 'rehype-stringify';
export { default as rehypeSanitize, defaultSchema } from 'rehype-sanitize';
export { default as remarkBreaks } from 'remark-breaks';
export { default as remarkGfm } from 'remark-gfm';
export { unified } from 'unified';
import { memo } from 'react';

export const Markdown = memo(MarkdownComponent);
